<template>
  <div>
    <div v-if="isLoading" class="mt-4">
      <Spinner />
    </div>
    <div v-else>
      <div v-if="using_policy">
        <a-alert 
          type="warning"
          style="margin-bottom: 10px"
          show-icon
        >
          <template #icon>
            <a-icon type="warning" theme="filled" />
          </template>
          <div slot="message">
            <b>Warning</b>
          </div>
          <p slot="description">
            This URL is currently already associated with a policy.
            To view and update the policy, please click <a :href="'/policy/' + policy_id" target="_blank">
              here
            </a>. However, 
            if you would like to override the policy for this specific URL,
            you may update the configurations directly on this page. 
          </p>
        </a-alert>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div>
          <a-select v-if="analysis_histories.length > 0" v-model="selected_history" default-value="Latest" style="width: 200px" @change="change_analysis_history">
            <a-select-option value="Latest">
              Latest analysis result
            </a-select-option>
            <a-select-option v-for="analysis in analysis_histories" :key="analysis.task_id">
              <a-popconfirm
                title="Are you sure delete this task?"
                ok-text="Yes"
                cancel-text="No"
                trigger="hover"
                :showCancel="false"
                placement="right"
                :auto-adjust-overflow="true"
                @confirm="()=>remove_analysis_record(analysis.task_id)"
              >
                {{ convert_timestamp(analysis.timestamp) }}
              </a-popconfirm>
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-tooltip placement="left">
            <template #title>
              Default algorithm: {{ analysis_methods[0].description }}
            </template>
            <a-dropdown-button type="primary" @click="()=>send_analysis_request({key:0})">
              Run Full Model Explainability
              <template #overlay>
                <a-menu @click="send_analysis_request">
                  <a-menu-item v-for="(algorithm, index) in analysis_methods" :key="index">
                    <a-tooltip>
                      <template #title>
                        {{ algorithm.description }}
                      </template>
                      {{ algorithm.name }}
                    </a-tooltip>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown-button>
          </a-tooltip>
        </div>
      </div>
      <div v-if="!loadingVerificationResult">
        <a-card v-if="en_probability !== undefined && en_proportion !== undefined" title="Language Detection" style="margin-top: 10px">
          <LanguagePredictionResult :englishProbability="en_probability" :englishProportion="en_proportion" />
        </a-card>
        <a-card v-if="defaced_confidence !== undefined && defaced_threshold !== undefined" title="Defacement Analysis" style="margin-top: 10px">
          <PredictionResult :defacedConfidence="defaced_confidence" :defacedThreshold="defaced_threshold" />
          <div style="display: flex; justify-content: flex-end;">
            <a-button type="primary" @click="manual_run_verification">
              Update defacement confidence
            </a-button>
          </div>
        </a-card>
      </div>
      <a-card v-if="text.length > 0" title="Explainability Results" style="margin-top: 10px">
        <template #extra>
          <div style="display: flex;">
            <div style="margin-top: 10px">
              <span>
                Display weights greater than:
              </span>
              <a-popover title="Note for word to ignore:">
                <template slot="content">
                  <div style="width: 300px;">
                    Drag the slider to display the words with weight greater than the threshold.
                  </div>
                </template>
                <a-icon class="explain" type="info-circle" theme="filled" />
              </a-popover>
            </div>
            <div style="margin-left: 15px">
              <a-slider v-model="display_threshold" style="max-width: 600px; min-width: 200px; width: 25vw;" :min="weight_min" :max="weight_max" :step="0.01" :marks="marks" @afterChange="filter_words" />
            </div>
            <a-input-number
              v-model="display_threshold"
              :min="weight_min"
              :max="weight_max"
              :step="0.01"
              style="margin-left: 16px;margin-top: 5px;"
            />
          </div>
        </template>
        <a-card :title="'HTML Text Being Analyzed' + (diff.length > 0 ? ' (Text Difference)': ' (Baseline Text)')"> 
          <template #extra>
            <div>
              Algorithm: {{ history_analysis_method }}
            </div>
          </template>
          <div class="analysis-text">
            <div v-for="(word, index) in word_splited" :key="index">
              <span v-if="!get_weight(word)">
                {{ word }}
              </span>
              <span v-else class="highlighted-word-outer">
                <div class="highlighted-word-inner-div">
                  <a-popover trigger="hover" title="Click to ignore this word: ">
                    <template slot="content">
                      <div style="text-align: center">
                        <p>Word "{{ word }}" has weight {{ get_weight(word) }}</p>
                        <div>
                          <a-button
                            v-if="!word_in_ignore_list(word)"
                            @click="() => add_word_to_ignore(word)"
                          >Add to ignore</a-button>
                          <a-button
                            v-if="word_in_ignore_list(word)"
                            type="danger"
                            @click="() => remove_word_to_ignore(word)"
                          >Remove from ignore</a-button>
                        </div>
                      </div>
                    </template>
                    <div style="margin: 4px;">
                      {{ word }}
                    </div>
                  </a-popover>
                  <span class="highlighted-word-weight">
                    {{ get_weight(word) }}
                  </span>
                </div>
              </span>
            </div>
          </div>
        </a-card>
        <!-- <a-card title="Word weight bar plot" style="margin-top: 10px">
          <div v-if="words.length > 0">
            <div
              v-for="(record, index) in words"
              :key="index"
              :class="['percentage', convert_percentage(record)]"
            >
              <span class="label-text">
                <a-popover trigger="hover" title="Click to ignore this word: ">
                  <template slot="content">
                    <div style="text-align: center">
                      <p>
                        Word "{{ record["word"] }}" has weight
                        {{ get_weight(record["word"]) }}
                      </p>
                      <div>
                        <a-button
                          v-if="!word_in_ignore_list(record['word'])"
                          @click="() => add_word_to_ignore(record['word'])"
                        >Add to ignore</a-button>
                        <a-button
                          v-if="word_in_ignore_list(record['word'])"
                          type="danger"
                          @click="() => remove_word_to_ignore(record['word'])"
                        >Remove from ignore</a-button>
                      </div>
                    </div>
                  </template>
                  <div>
                    {{ get_record_text(record) }}
                  </div>
                </a-popover>
              </span>
            </div>
          </div>
          <div v-else style="margn-left: 20px">
            No word has weight greater than selected weight!
          </div>
        </a-card> -->
        <a-card title="Words With Highest Defacement Weight" style="margin-top: 10px">
          <ol v-if="words.length > 0">
            <li v-for="(record, index) in words" :key="index" style="margin-top: 8px">
              <span v-if="record['word'].length > 27">
                {{ record['word'] }}...
              </span>
              <span v-else>
                {{ record['word'] }}
              </span>
              <a-tag
                v-if="!word_in_ignore_list(record['word'])"
                style="margin-left: 10px"
                color="blue"
              >
                Weight: {{ get_weight(record['word']) }}
              </a-tag>
              <a-tag
                v-if="!word_in_ignore_list(record['word'])"
                color="green"
                style="margin-left: 10px"
                @click="() => add_word_to_ignore(record['word'])"
              >
                + Add to ignore
              </a-tag>
              <a-tag
                v-else
                color="red"
                style="margin-left: 10px"
                @click="() => remove_word_to_ignore(record['word'])"
              >
                Remove from ignore
              </a-tag>
            </li>
          </ol>
          <div v-else style="margn-left: 20px">
            No word has weight greater than selected weight!
          </div>
        </a-card>
        <a-card style="margin-top: 10px">
          <template #title>
            <span style="font-weight: 600">
              Words To be Ignored:
            </span>
            <a-popover title="Note for word to ignore:">
              <template slot="content">
                <div style="width: 300px">
                  Some words in the website content is not learned by the model and may trigger alert. You can ignore these words to prevent false alert.
                </div>
              </template>
              <a-icon class="explain" type="info-circle" theme="filled" />
            </a-popover>
          </template>
          <div>
            <template v-for="word in words_ignored">
              <a-tooltip v-if="word.length > 27" :key="word" :title="word">
                <a-tag
                  :key="word"
                  color="red"
                  :closable="true"
                  @close="() => remove_word_to_ignore(word)"
                >
                  {{ `${word.slice(0, 27)}...` }}
                </a-tag>
              </a-tooltip>
              <a-tag
                v-else
                :key="word"
                color="red"
                :closable="true"
                @close="() => remove_word_to_ignore(word)"
              >
                {{ word }}
              </a-tag>
            </template>
            <span v-if="add_word_ignored_visiable">
              <a-input
                ref="input"
                type="text"
                size="small"
                :style="{ width: '78px' }"
                :value="input_word_to_ignore"
                @change="input_word_to_ignore_change"
                @keyup.enter="handle_add_word_to_ignore_confirm"
              />
              <a-button size="large" style="margin-left: 5px" @click="handle_add_word_to_ignore_confirm">
                Add
              </a-button>
            </span>
            <a-tag
              v-else
              style="background: #fff; borderstyle: dashed"
              @click="show_add_word_ignored_visiable"
            >
              <a-icon type="plus" /> Add word to ignore
            </a-tag>
          </div>
        </a-card>
      </a-card>
      <!-- <a-alert
        v-if="analysis_histories.length > 0 && words.length < 1"
        message="Analysis request is processing"
        description="The analysis request is processing, please wait for a while and check the history for results."
        type="info"
        show-icon
        style="margin-top: 30px"
      /> -->
      <!-- <div v-else class="mt-4">
        <Spinner />
      </div> -->
    </div>
  </div>
</template>

<script>
import ApiService from '@shared/services/api.service';
import WebpageService from "../../services/webpage.service";
import { notification } from 'ant-design-vue';
import LanguagePredictionResult from "../NLPComponents/LanguagePredictionResult";
import PredictionResult from "../NLPComponents/PredictionResult";
const analysis_methods = {
  distilbert: [
    {
      name: "Attention Weight",
      value: "distilbert_attention_analysis",
      description: "This algorithm shows the word that carries the highest defacement weights."
    },
    {
      name: "Intelligent Weight",
      value: "evaluate_bert_by_remove_words",
      description: "This algorithm tests each word in the HTML content to see which word affects the weight the most. Note that this analysis may take some time."
    },
  ],
  xgboost: [
    {
      name: "Intelligent Weight",
      value: "explain_xgboost_lime",
      description: "This algorithm tests each word in the HTML content to see which word affects the weight the most. Note that this analysis may take some time."
    },
  ],
};
export default {
  name: "NLPAnalysisResult",
  components: {
    LanguagePredictionResult, PredictionResult
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    urlID: {
      type: Number,
      required: false,
      default: -1,
    },
    runOnstart: {
      type: Boolean,
      required: false,
      default: false,
    },
    diff: {
      type: String,
      required: false,
      default: "",
    },
    modalClosed: {
      type: Boolean,
      required: true,
      default: false,
    }
  },
  data() {
    return {
      closed: false,
      url_id: null,
      isLoading: false,
      text: "",
      en_probability: undefined,
      en_proportion: undefined,
      defaced_confidence: undefined,
      defaced_threshold: undefined,
      input_word_to_ignore: "",
      add_word_ignored_visiable: false,
      analysis_histories: [],
      words_ignored: [],
      selected_history: "Latest",
      analysis_methods: analysis_methods[this.model.model],
      display_threshold: 0,
      current_analysis_id: "",
      weight_min: 0,
      display_table: false,
      weight_max: 1,
      words: [],
      word_to_weight_mapping: {},
      word_list: [],
      display_result: false,
      history_analysis_method: "",
      loadingVerificationResult: false,
      retrieve_result_interval_timer: null,
      result_changed: false,
      using_policy: false,
      policy_id: null,
      marks: {
        0: {
          label: <span>0</span>,
        },
      },
    };
  },
  computed: {
    word_splited() {
      return this.text.split(" ");
    },
  },
  watch: {
    model: {
      handler() {
        this.setConfig();
      },
      deep: true,
    },
    modalClosed: {
      handler(){
        this.closed = this.modalClosed;
        if (this.modalClosed){
          if (this.runOnstart && this.diff){
            this.send_analysis_request({key:0, text: this.diff});
          } else {
            this.list_analysis_history();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.url_id = this.urlID > 0 ? this.urlID : this.$route.params.id;
    this.setConfig();
    if (this.runOnstart && this.diff){
      this.send_analysis_request({key:0, text: this.diff});
    } else {
      this.list_analysis_history();
    }
    this.isLoading = false;
  },
  methods: {
    async nlp_engine_update_configurations(){
      if (this.using_policy){
        return;
      }
      const new_model = {
        model: this.model.model,
        threshold: this.model.threshold,
        words_ignored: this.words_ignored
      }
      await ApiService.post(`urls/${this.url_id}/nlp/config`, new_model).then(res=>{
        if (res === "success" || res === "not updated"){
          notification.open({
            message: 'Configurations updated successfully!',
            description: 'Configurations updated successfully!',
            duration: 3
          });
          return;
        } else {
          notification.open({
            message: 'Error in updating configurations',
            description: 'The configuration update failed, please check and try again later!',
            duration: 6
          });
          return;
        }
      }).catch(e=>{
        console.log(e);
      });
    },
    async manual_run_verification(){
      this.loadingVerificationResult = true;
      await this.nlp_engine_update_configurations();
      await this.run_verification();
    },
    async run_verification(){
      this.loadingVerificationResult = true;
      const verification_request = {
        'models': [this.model.model],
        'use_latest_baseline': true,
      };
      if (this.diff){
        verification_request['use_latest_baseline'] = false;
        verification_request['text'] = this.diff;
      } else if (this.text && this.text.length > 0) {
        verification_request['use_latest_baseline'] = false;
        verification_request['text'] = this.text;
      }
      await WebpageService.nlp_manual_verify(this.url_id, verification_request).then(res=>{
        if (res.result){
          const result = res.result[0];
          this.en_probability = result.english_probability;  
          this.en_proportion = result.english_proportion;
          if (result.predictions && result.predictions[this.model.model]){
            const prediction = result.predictions[this.model.model];
            this.defaced_confidence = prediction.confidence;
            if (result.user_config && result.user_config[this.model.model]){
              const model_config = result.user_config[this.model.model];
              this.defaced_threshold = model_config.threshold;
            }
          }
        }
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{
        this.loadingVerificationResult = false;
      });
    },
    word_in_ignore_list(word){
      const result = this.words_ignored.filter(w => w === word);
      if (result.length > 0) {
        return true;
      }
    },
    filter_words(threshold){
      const result_words = this.word_list.filter(
        word => word.weight > threshold && word.weight >= 0.005
      );
      result_words.sort((a, b) => b.weight - a.weight);
      this.display_threshold = threshold;
      this.words = result_words;
    },
    change_display_option(){
      this.display_table = !this.display_table;
    },
    map_weight_to_word(){
      const map = {};
      this.word_list.forEach(info => {
        map[info.word] = info.weight;
      });
      this.word_to_weight_mapping = map;
    },
    assign_analysis_result(res){
      this.display_result = false;
      const model_algorithms = analysis_methods[this.model.model];
      const history_algorithm = res.analysis_method;
      const method = model_algorithms.filter(
        m => m.value === history_algorithm
      );
      if (method.length > 0) {
        this.history_analysis_method = method[0].name;
      }
      const result = res.result;
      if (result){
        this.text = result.text;
        const words = result.words.filter(word => word.weight > 0);
        this.en_probability = result.english_probability
        this.en_proportion = result.english_proportion
        this.defaced_threshold = res.threshold;
        this.defaced_confidence = result.confidence;
        this.word_list = words;
        this.get_weight_min();
        this.get_weight_max();
        this.filter_words(Math.round((this.weight_min + this.weight_max) * 50) / 100);
        this.map_weight_to_word();
        this.display_result = true;
        this.isLoading = false;
      }
    },
    async send_analysis_request(e){
      // this.isLoading = true;
      await  this.nlp_engine_update_configurations();
      const index = e.key;
      const algorithm = this.analysis_methods[index].value;
      const analysis_request = {
        'model_name': this.model.model,
        'analysis_method': algorithm,
      };
      if (this.diff && this.diff.length > 0){
        analysis_request['text'] = this.diff;
      } 
      WebpageService.nlp_analysis_request(this.url_id, analysis_request)
        .then((res) => {
          if (res.result === null){
            notification.error({
              message: 'Server side error!',
              duration: 10
            });
            return;
          }
          if (res.result.status === 'added'){
            notification.info({
              message: 'Analysis request submitted!',
              description: 'The analysis request is added, please come back later to check the result.',
              duration: 5
            });
            return;
          }
          else if (res.result.status === 'pending' || res.result.result === null){
            notification.open({
              message: 'Analysis request is processing!',
              description: 'The analysis request is added, please come back later to check the result.',
              duration: 6
            });
            return;
          }
          if (res.message){
            const message = res.message;
            notification.open({
              message: 'Duplicated analysis request!',
              description: message,
              duration: 6
            });
          }
          const result = res.result;
          this.assign_analysis_result(result);
        }).then(()=>{
          this.retrieve_result_interval_timer = setInterval(()=>{
            if (this.text.length > 0 || this.closed) {
              clearInterval(this.retrieve_result_interval_timer);
            }
            this.list_analysis_history();
          }, 5000);
        })
        .catch((error) => {
          console.log(error);
          // this.$showMultiErrorMessage(error.messages);
        })
        .finally(()=>{
          this.isLoading = false;
        });
    },
    async list_analysis_history(){
      // this.isLoading = true;
      WebpageService.nlp_analysis_history_list(this.url_id)
        .then((res) => {
          let histories =  res.history.filter(h=>h.model_name === this.model.model);
          histories = histories.sort((a, b)=> { return new Date(b.timestamp) - new Date(a.timestamp)});
          this.analysis_histories = histories;
          if (this.analysis_histories.length > 0){
            this.current_analysis_id = this.analysis_histories[0].task_id;
          }
        }).then(()=>{
          if (this.current_analysis_id.length > 0){
            this.retrieve_analysis_result(this.current_analysis_id);
          }
        })
        .catch((error) => {
          console.log(error);
          // this.$showMultiErrorMessage(error.messages);
        }).finally(()=>{
          this.isLoading = false;
        })
    },
    async retrieve_analysis_result(task_id){
      // this.isLoading = true;
      WebpageService.nlp_analysis_result(this.url_id, {
        'task_id': task_id
      })
        .then((res) => {
          if (res.result.status === 'pending' || res.result === null || res.result.result === null){
            notification.open({
              message: 'Analysis request is processing!',
              description: 'The analysis request is added, please come back later to check the result.',
              duration: 3
            });
            return;
          }
          const result = res.result;
          this.assign_analysis_result(result);
        })
        .catch((error) => {
          console.log(error);
          // this.$showMultiErrorMessage(error.messages);
        }).finally(()=>{
          // this.isLoading = false;
        });
    },
    async change_analysis_history(task_id){
      // select another analysis history to display
      // this.isLoading = true;
      if (task_id === "Latest"){
        if (this.analysis_histories.length > 0){
          task_id = this.analysis_histories[0].task_id
        }
      }
      await this.retrieve_analysis_result(task_id)
      .catch((error)=>{
        console.log(error)
      }).finally(()=>{
        // this.isLoading = false;
      });
    },
    setConfig(){
      this.using_policy = !!this.model.policy;
      this.policy_id = this.model.policy;
      this.words_ignored = this.model.words_ignored;
      this.analysis_methods = analysis_methods[this.model.model];
    },
    convert_timestamp(timestamp){
      const new_time = new Date(timestamp + ' GMT-0000');
      return new_time.toDateString() + " " + new_time.toTimeString().slice(0, 8);
    },
    // for displaying analysis weight
    get_weight(word) {
      word = word.toLowerCase();
      let weight = 0;
      if (word in this.word_to_weight_mapping) {
        weight = this.word_to_weight_mapping[word];
      } else if (word.substring(0, word.length - 1) in this.word_to_weight_mapping) {
        const new_word = word.substring(0, word.length - 1);
        weight = this.word_to_weight_mapping[new_word];
      } else {
        return 0;
      }

      if (weight && weight > this.display_threshold){
        const weight_str = weight.toFixed(2);
        if (weight_str === '0.00') {
          return 0;
        }
        return weight_str;
      }
      return 0;
    },
    get_weight_min(){
      if (this.word_list.length < 1) {
        this.weight_min = 0;
        return;
      }
      const min_weight = parseFloat(Math.min(...this.word_list.map(word => word.weight)).toFixed(2));
      this.weight_min = Math.max(0, min_weight - 0.01);
    },
    get_weight_max(){
      if (this.word_list.length < 1) {
        this.weight_max = 1;
        return;
      }
      const max_weight =parseFloat(Math.max(...this.word_list.map(word => word.weight)).toFixed(2))??1; 
      this.weight_max = (max_weight > 0) ? max_weight + 0.01 : 0.01;
    },
    get_record_text(record) {
      return record["word"] + ": " + this.get_weight(record["word"]);
    },
    convert_percentage(record) {
      return "percentage-" + Math.round(record["weight"] * 100);
    },
    // for adding word to ignore
    show_add_word_ignored_visiable() {
      this.add_word_ignored_visiable = true;
      this.input_word_to_ignore = "";
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    input_word_to_ignore_change(e) {
      this.input_word_to_ignore = e.target.value;
    },
    handle_add_word_to_ignore_confirm() {
      let words = this.words_ignored;
      if (!this.input_word_to_ignore) {
        this.$message.error("Please enter the word to ignore!");
        return;
      }
      if (words.includes(this.input_word_to_ignore)) {
        this.$message.error(`Word "${this.input_word_to_ignore}" already in ignore list!`);
        return;
      }else {
        words = [...words, this.input_word_to_ignore];
        this.words_ignored = words;
        this.$message.success(`Word "${this.input_word_to_ignore}" added to ignore list!`);
      }
      this.add_word_ignored_visiable = false;
      this.input_word_to_ignore = "";
      this.updateParent();
    },
    add_word_to_ignore(word) {
      let words = this.words_ignored;
      if (words.indexOf(word) === -1) {
        words = [...words, word];
        this.words_ignored = words;
        this.$message.success(`Word "${word}" added to ignore list!`);
        this.updateParent();
      } else {
        this.$message.error(`Word "${word}" already in ignore list!`);
      }
    },
    remove_word_to_ignore(word) {
      const words = this.words_ignored.filter((w) => w !== word);
      this.words_ignored = words;
      this.$message.info(`Word "${word}" removed from ignore list!`);
      this.updateParent();
    },
    updateParent() {
      this.$emit("change", {
        words_ignored: this.words_ignored,
      });
    },
    async remove_analysis_record(task_id){
      // select another analysis history to display
      // this.isLoading = true;
      if (task_id === "Latest"){
        if (this.analysis_histories.length > 0){
          task_id = this.analysis_histories[0].task_id
        }
      }
      await WebpageService.nlp_analysis_record_remove(this.url_id, {
        'task_id': task_id
      }).then((res)=>{
        if (res === "success"){
          notification.open({
            message: 'Analysis record removed!',
            description: 'Analysis record removed!',
            duration: 3
          });
          this.list_analysis_history();
        } else {
          this.$message.error("Failed to remove the analysis record!");
        }
      })
      .catch((error)=>{
        console.log(error)
      }).finally(()=>{
        // this.isLoading = false;
      });
    }
  },
};
</script>
<style>
.ant-popover.ant-popover-placement-right{
  z-index: 1060;
}
</style>
<style lang="scss" scoped>
.interpretability-head{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.interpretability-head-buttons{
  justify-content: space-between;
}
.interpretability-head-slider{
  margin-left: 10px;
  justify-content: flex-start;
}
.words_ignored_outer{
  padding: 5px; 
  background-color: rgb(254, 251, 230); 
  border: 1px solid #ffe58f; 
  border-radius: 5px;
}
.analysis-text {
  justify-content: space-between;
  line-height: 42px;
  display: flex;
  flex-wrap: wrap;
  white-space: pre-wrap;
  -webkit-box-align: initial;
  align-items: initial;
  margin-top: 3px;
  width: 100%;
}
.analysis-text::after {
  content: "";
  flex: auto;
}
.highlighted-word-outer {
  border: 2px solid rgb(241, 196, 15);
  margin: 4px 8px 4px 4px;
  box-shadow: 2px 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  cursor: default;
  min-width: 24px;
  line-height: 22px;
  color: rgb(71, 81, 92);
  background: rgba(240, 126, 0, 0.1);
  transition: background-color 0.1s ease 0s, box-shadow 0.1s ease 0s, opacity 0.1s ease 0s;
  display: block;
  white-space: normal;
}
.highlighted-word-outer span {
  transition: background-color 0.1s ease 0s, box-shadow 0.1s ease 0s, opacity 0.1s ease 0s;
}
.highlighted-word-inner-div {
  display: flex;
  flex-direction: column;
}
.highlighted-word-inner-button {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  align-items: center;
  padding: 2px 2px 2px 4px;
}
.highlighted-word-weight {
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  display: flex;
  padding: 0px 8px;
  text-align: center;
  user-select: none;
  background: rgb(241, 196, 15);
  font-size: 0.8125rem;
}
.bar-plot-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  position: relative;
  padding: 20px;
}
.label-text {
  font-weight: 600;
  display: flex;
  align-items: center;
  height: 30px;
  width: 130px;
  position: absolute;
  left: 0;
  justify-content: flex-end;
}
.percentage {
  font-size: 1em;
  line-height: 1;
  width: 100%;
  height: 30px;
  margin-left: 130px;
  border-left: 1px solid black;
  &:after {
    content: "";
    display: block;
    background-color: rgb(241, 196, 15);
    width: 300px;
    margin-bottom: 10px;
    height: 90%;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    transition: background-color 0.3s ease;
  }
}
@for $i from 0 through 10000 {
  .percentage-#{$i} {
    &:after {
      $value: ($i * 0.05%);
      width: $value;
    }
  }
}
</style>
